import React from "react";
import PropTypes from "prop-types";
import { truncate } from "lodash";

import { Icon, Label } from "semantic-ui-react";

export default function CommentFilterItem({
  typeName,
  iconName,
  title,
  removeFilter,
}) {
  return (
    <Label data-test={`filter-item-${typeName}`} onClick={removeFilter}>
      <Icon name={iconName} aria-label={`${typeName}`} />
      {truncate(title, { length: 21, omission: "…" })}
      <Icon name="delete" />
    </Label>
  );
}

CommentFilterItem.propTypes = {
  typeName: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  removeFilter: PropTypes.func.isRequired,
};
